var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { ArrowLeft02Icon } from 'hugeicons-react';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetMachineLibraryDetailQuery } from '../../../../../application/features/machines/machine-api';
import useTranslate from '../../../../../localization/helpers';
import FilterButton from '../../../../components/FilterButton';
import MachineLibraryDetailsCards from './machine-library-details-cards';
import MachineLibraryDetailsGrid from './machine-library-details-grid';
import MachineLibraryDcoumentDialog from './machine-library-document-dialog';
var MachineLibraryDetails = function () {
    var theme = useTheme();
    var navigate = useNavigate();
    var machineId = useParams().machineId;
    var translate = useTranslate().translate;
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var isSm = useMediaQuery(theme.breakpoints.only('sm'));
    var isMd = useMediaQuery(theme.breakpoints.only('md'));
    var isLg = useMediaQuery(theme.breakpoints.up('lg'));
    var isIpadMini = useMediaQuery('(max-width: 768px)');
    var isIpadMiniLandscape = useMediaQuery('(max-width: 1024px) and (orientation: landscape)');
    var isscreen600900 = useMediaQuery('(min-width:600px) and (max-width:900px)');
    var iscreen9001200 = useMediaQuery('(min-width:900px) and (max-width:1200px)');
    var isscreen9001200Landscape = useMediaQuery('(min-width:901px) and (max-width:1201px) and (orientation: landscape)');
    var isscreen600900Landscape = useMediaQuery('(min-width:600px) and (max-width:900px) and (orientation: landscape)');
    var _a = __read(useState(false), 2), documentDialogOpen = _a[0], setDocumentDialogOpen = _a[1];
    var _b = __read(useState([]), 2), filteredModels = _b[0], setFilteredModels = _b[1];
    var _c = __read(useState(), 2), selectedModelWithDocuments = _c[0], setSelectedModelWithDocuments = _c[1];
    var _d = __read(useState([]), 2), selectedModels = _d[0], setSelectedModels = _d[1];
    var _e = __read(useState(false), 2), openFilterDrawer = _e[0], setOpenFilterDrawer = _e[1];
    var machineWithDocuments = useGetMachineLibraryDetailQuery(machineId, {
        skip: !machineId
    }).data;
    var modelWithDocuments = useMemo(function () { var _a; return (_a = machineWithDocuments === null || machineWithDocuments === void 0 ? void 0 : machineWithDocuments.modelWithDocuments) !== null && _a !== void 0 ? _a : []; }, [machineWithDocuments === null || machineWithDocuments === void 0 ? void 0 : machineWithDocuments.modelWithDocuments]);
    useEffect(function () {
        var filteredMachineModels = modelWithDocuments.map(function (item, index) { return (__assign({ id: index + 1 }, item)); });
        setFilteredModels(filteredMachineModels);
    }, [modelWithDocuments]);
    var handleModelChange = function (value) {
        setSelectedModels(value);
    };
    var handleModelSearch = function () {
        var machineModels = __spreadArray([], __read(modelWithDocuments), false);
        if (selectedModels.length)
            machineModels = machineModels.filter(function (m) { return selectedModels.includes(m.modelNumber); });
        var filteredModels = machineModels.map(function (item, index) { return (__assign({ id: index + 1 }, item)); });
        setFilteredModels(filteredModels);
    };
    var modelNumbersList = useMemo(function () { return modelWithDocuments.map(function (model) { return model.modelNumber; }); }, [modelWithDocuments]);
    var columns = useMemo(function () { return [
        {
            field: 'modelNumber',
            headerName: translate('assets.modelNumber'),
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 1 : 1,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            renderCell: function (params) { return (_jsx(Box, { display: 'flex', gap: 2, my: 1.5, children: _jsx(Typography, { title: String(params.row.modelNumber), variant: 'body2', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', children: String(params.row.modelNumber) }) })); }
        },
        {
            field: 'documents',
            headerName: translate('common.documents'),
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 1 : 1,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined
        },
        {
            field: 'documentActions',
            headerName: translate('assets.documentActions'),
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 1 : 1,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            headerAlign: 'center',
            renderCell: function (params) { return (_jsx(Box, { maxWidth: '100%', justifyContent: 'center', display: 'flex', alignItems: 'center', height: '100%', children: _jsx(Button, { onClick: function () {
                        setDocumentDialogOpen(true);
                        setSelectedModelWithDocuments(params.row);
                    }, variant: 'soft', disabled: params.row.documents === 0, size: isXs ? 'small' : 'medium', children: translate('actions.view') }) })); }
        }
    ]; }, [
        isXs,
        isMd,
        isscreen600900,
        isSm,
        translate,
        setDocumentDialogOpen,
        setSelectedModelWithDocuments
    ]);
    return (_jsx(_Fragment, { children: _jsxs(Box, { sx: {
                padding: isXs ? '16px' : '8px',
                display: 'flex',
                flexDirection: 'column',
                gap: '20px'
            }, children: [_jsxs(Box, { display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: isXs || isscreen600900 || iscreen9001200 || isscreen600900Landscape
                        ? 'space-between'
                        : '', mb: { xs: 0, md: 0, lg: 2 }, children: [_jsx(Box, { display: 'flex', alignItems: 'center', gap: 1, children: _jsxs(Box, { display: 'flex ', alignItems: 'center', children: [_jsx(IconButton, { size: isXs ? 'small' : isscreen600900 ? 'medium' : 'large', color: 'primary', onClick: function () {
                                            navigate("/assets?tab=AssetLibrary");
                                        }, children: _jsx(ArrowLeft02Icon, { size: isXs ? 20 : isscreen600900 ? 20 : 32 }) }), _jsx(Typography, { variant: isXs ? 'h3' : isscreen600900 ? 'h4' : 'h3', color: '#009983', fontWeight: 600, children: translate('assets.modelDocs') })] }) }), !isXs && !isIpadMini && !isIpadMiniLandscape && !isLg && _jsx(FilterButton, { variant: 'soft' })] }), isXs || isIpadMini || isIpadMiniLandscape ? (_jsx(MachineLibraryDetailsCards, { filteredModels: filteredModels, isXs: isXs, iscreen9001200: iscreen9001200, isscreen600900: isscreen600900, isscreen9001200Landscape: isscreen9001200Landscape, openFilterDrawer: openFilterDrawer, setOpenFilterDrawer: setOpenFilterDrawer, handleModelChange: handleModelChange, handleModelSearch: handleModelSearch, machineModel: machineWithDocuments, modelNumbersList: modelNumbersList, setSelectedModelWithDocuments: setSelectedModelWithDocuments, setDocumentDialogOpen: setDocumentDialogOpen, selectedModels: selectedModels, setSelectedModels: setSelectedModels })) : (_jsx(_Fragment, { children: _jsx(MachineLibraryDetailsGrid, { columns: columns, filteredModels: filteredModels, handleModelChange: handleModelChange, handleModelSearch: handleModelSearch, isXs: isXs, iscreen9001200: iscreen9001200, isscreen600900: isscreen600900, isscreen9001200Landscape: isscreen9001200Landscape, machineModel: machineWithDocuments, modelNumbersList: modelNumbersList, openFilterDrawer: openFilterDrawer, selectedModels: selectedModels, setOpenFilterDrawer: setOpenFilterDrawer, setSelectedModels: setSelectedModels }) })), _jsx(MachineLibraryDcoumentDialog, { isOpen: documentDialogOpen, onClose: function () { return setDocumentDialogOpen(false); }, machine: machineWithDocuments, selectedModelWithDocuments: selectedModelWithDocuments })] }) }));
};
export default MachineLibraryDetails;
